<template>
  <div class="DataSearch" @click="closeFilter">
    <div class="DataSearch_box" @click.stop="bubbleFun()">
      <div class="select_condition">
        <div>
          <div class="select_num" >
            {{$t('DataHub.Select')}}: {{goalsIdList.length + dataIdList.length +keyIdList.length +sourcsIdList.length }} 
           
          </div>
        </div>
        <div class="right_box">
          <div class="search">
            <div class="clear_btn" @click="clearAll()">
              {{$t('DataHub.Clear')}}
              <i class="iconfont icon-shanchu3"></i>
            </div>
          </div>
          <div class="search">
            <div class="clear_btn" @click="closeFilter">
              {{$t('DataHub.Close')}}
              <i class="iconfont icon-iconclose"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 1 -->
      <div class="condition_box target">
        <div class="condition_box_tit">{{$t('DataHub.Goal')}}:</div>
        <div class="condition_box_content">
          <div
            class="img_box"
            :class="[goalsIdList.indexOf(item) > -1 ? 'h70' : 'h40']"
            v-for="(item, index) in goals"
            :key="index"
            :style="{ background: bg_color[index + 1] }"
            @click="addGoalsId(item)"
          >
            <div
              v-if="goalsIdList.indexOf(item) > -1"
              class="select"
              :style="{ color: bg_color[index + 1] }"
            >
              <i class="iconfont icon-xuanzhong1"></i>
            </div>
            <div v-if="goalsIdList.indexOf(item) > -1" class="active_sdg"></div>
            <img
              :src="
                require(`../../../assets/image/SmallIcon/sdg_small_${
                  index + 1
                }.png`)
              "
              alt
            />
          </div>
        </div>
      </div>
      <!-- 2 -->
      <div class="condition_box">
        <div class="condition_box_tit">{{$t('DataHub.Format')}}:</div>
        <div class="condition_box_content">
          <div class="txt" v-for="(item, index) in data" :key="index">
            <div
              class="data_box"
              @click="addData(item)"
              :class="[dataIdList.indexOf(item) > -1 ? 'activeCondition' : '']"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 3 -->
      <div class="condition_box">
        <div class="condition_box_tit">{{$t('DataHub.Keywords')}}:</div>
        <div class="condition_box_content">
          <div class="txt" v-for="(item, index) in key" :key="index">
            <div
              class="data_box"
              @click="addkey(item)"
              :class="[keyIdList.indexOf(item) > -1 ? 'activeCondition' : '']"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 4 -->
      <div class="condition_box">
        <div class="condition_box_tit">{{$t('DataHub.Source')}}:</div>
        <div class="condition_box_content">
          <div class="txt" v-for="(item, index) in source" :key="index">
            <div
              class="data_box"
              @click="addSource(item)"
              :class="[
                sourcsIdList.indexOf(item) > -1 ? 'activeCondition' : '',
              ]"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/bus";
import { dataset } from "@/axios/datashare.js";
export default {
  comments: {},
  data() {
    return {
      bg_color: [
        "rgba(200, 200, 200, 1)",
        "rgba(235, 28, 44, 1)",
        "rgba(209, 159, 40, 1)",
        "rgba(38, 155, 71, 1)",
        "rgba(194, 31, 50, 1)",
        "rgba(239, 62, 42, 1)",
        "rgba(0, 173, 217, 1)",
        "rgba(252, 182, 21, 1)",
        "rgba(142, 23, 55, 1)",
        "rgba(243, 108, 36, 1)",
        "rgba(225, 21, 132, 1)",
        "rgba(249, 156, 36, 1)",
        "rgba(207, 141, 41, 1)",
        "rgba(70, 118, 59, 1)",
        "rgba(0, 124, 187, 1)",
        "rgba(62, 175, 73, 1)",
        "rgba(1, 85, 138, 1)",
        "rgba(24, 53, 103, 1)",
      ],
      goalsIdList: [], //选中的goalsId
      dataIdList: [],
      keyIdList: [],
      sourcsIdList: [],
      data: [],
      goals: [],
      key: [],
      source: [],
    };
  },
  mounted() {
    this.getDataset();
  },
  watch: {
    goalsIdList(val) {
      bus.$emit("showDataList", { goals: val });
    },
    dataIdList(val) {
      bus.$emit("showDataList", { formats: val });
    },
    keyIdList(val) {
      bus.$emit("showDataList", { keywords: val });
    },
    sourcsIdList(val) {
      bus.$emit("showDataList", { sources: val });
    },
  },
  methods: {
    closeFilter() {
      bus.$emit("cloneFilter", false);
    },
    bubbleFun() {},
    searchData() {
      // this.getDatasetList()
    },
    addData(obj) {
      var dataId = this.dataIdList.indexOf(obj);
      if (dataId == -1) {
        this.dataIdList.push(obj);
      } else {
        this.dataIdList.splice(dataId, 1);
      }
    },
    addkey(obj) {
      var dataId = this.keyIdList.indexOf(obj);
      if (dataId == -1) {
        this.keyIdList.push(obj);
      } else {
        this.keyIdList.splice(dataId, 1);
      }
    },
    addSource(obj) {
      var dataId = this.sourcsIdList.indexOf(obj);
      if (dataId == -1) {
        this.sourcsIdList.push(obj);
      } else {
        this.sourcsIdList.splice(dataId, 1);
      }
    },
    addGoalsId(obj) {
      var haveGoalsId = this.goalsIdList.indexOf(obj);
      if (haveGoalsId == -1) {
        this.goalsIdList.push(obj);
      } else {
        this.goalsIdList.splice(haveGoalsId, 1);
      }
    },
    clearAll() {
      this.goalsIdList = [];
      this.dataIdList = [];
      this.keyIdList = [];
      this.sourcsIdList = [];
    },

    async getDataset() {
      var res = await dataset();
      this.data = res.data.data[0].value;
      this.goals = res.data.data[1].value;
      this.key = res.data.data[2].value;
      this.source = res.data.data[3].value;
    },
  },
};
</script>

<style scoped lang="scss">
.DataSearch {
  position: absolute;
  top: 0px;
  min-height: 100vh;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  //   margin: 0px auto;
  z-index: 999;

  .DataSearch_box {
    padding: 0 20px 10px;
    background: #f7f5f5;
    top: 0px;
    width: 100%;
    // height: 100%;
    // z-index: 10;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    // border-radius: 10px;
    box-shadow: 2px 2px 5px #ccc;
    // 选中
    .select_condition {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;
      // padding-top: 20px;
      border-bottom: 1px solid #d8d8d8;
      .select {
        min-width: 90px;
        font-size: 14px;
        color: #999;
        font-weight: 600;
        margin-right: 10px;
      }
       .select_num{
              font-weight: 600;
              color: rgba(10, 151, 217, 1)
          }
      .right_box{
          display: flex;
          flex-direction: row;
         
           .search {
        max-width: 160px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        div {
          margin-left: 10px;
          padding: 6px 10px;
          border-radius: 5px;
          font-size: 14px;
          cursor: pointer;
        }
        // .search_btn:hover {
        //   opacity: 0.7;
        //   transition: 0.1s;
        // }
        .search_btn {
          transition: 0.1s;
          color: #fff;
          background: rgba(10, 151, 217, 1);
          border: 1px solid rgba(10, 151, 217, 1);
        }
     
        .clear_btn {
          transition: 0.1s;
          box-sizing: border-box;
          color: #666;
          font-size: 14px;
          i {
            margin-left: 6px;
            font-size: 16px;
          }
          border: 1px solid transparent;
        }
      }
      }
     

      .select_content {
        flex: 1;
        .back_data {
          width: fit-content;
          background: rgba(10, 151, 217, 1);
        }
        .back_sdgs {
          width: fit-content;
          background: rgba(63, 126, 68, 1);
        }
        .back_key {
          width: fit-content;
          background: rgba(89, 192, 43, 1);
        }
        .back_sourcs {
          width: fit-content;
          background: rgba(0, 104, 157, 1);
        }

        .SDGs {
          flex: 1;
          max-width: 100%;
          margin-bottom: 6px;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 4px 10px;
          flex-wrap: wrap;
          border-radius: 4px;
          color: #fff;
          box-shadow: 2px 2px 4px #666;
          .title {
            min-width: 70px;
            // font-weight: 600;
            font-size: 16px;
            margin-right: 10px;
          }
          .SDGs_box_con {
            flex: 1;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            .SDGs_box {
              // margin-right: 6px;
            }
          }
          .icon {
            min-width: 30px;
            cursor: pointer;
            margin-left: 20px;
            i {
              font-size: 26px;
              color: #fff;
              &:hover {
                color: #ccc;
              }
            }
          }
        }
      }
    }
    .condition_box:last-child {
      border-bottom: none !important;
    }

    .condition_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      padding-bottom: 10px;
      padding-top: 10px;
      border-bottom: 1px solid #d8d8d8;
      .condition_box_tit {
        width: 90px;
        font-size: 14px;
        color: #999;
        font-weight: 600;
        margin-right: 10px;
      }

      .condition_box_content {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .img_box {
          // margin-top: 10px;
          margin-bottom: 8px;
          cursor: pointer;
          margin-right: 8px;
          transition: 0.2s;
          width: 40px;

          position: relative;
          .active_sdg {
            position: absolute;
            bottom: 1px;
            right: 1px;
            width: 0;
            height: 0;
            border-bottom: 20px solid #fff;
            border-left: 20px solid transparent;
          }
          .select {
            position: absolute;
            right: 0px;
            bottom: 0px;
            z-index: 11;
            i {
              font-size: 6px;
              font-weight: 600;
            }
          }
          img {
            width: 40px;
            height: 40px;
          }
        }

        .txt {
          display: flex;
          flex-direction: row;
          margin-right: 8px;
          font-size: 14px;
          margin-bottom: 6px;
          background: #fff;
          position: relative;
          border-radius: 4px;
          box-sizing: border-box;
          .data_box {
            padding: 4px 10px;
            border-radius: 4px;
          }
          .activeCondition {
            //   position: absolute;
            border: 1px solid #2958ff;
            color: #2958ff;
            background: rgba(0, 104, 157, 0.1);
            //           bottom: 1px;
            //             right: 1px;
            //             width: 0;
            //             height: 0;
            //             border-bottom: 20px solid #fff;
            //             border-left: 20px solid transparent;
          }
          .cursor {
            cursor: pointer;
          }
        }
      }
      .condition_box_select {
        padding: 4px 10px;
        border-radius: 2px;
        border: 1px solid #ccc;
        font-size: 12px;
        cursor: pointer;
        &:hover {
          background: #f8f8f8;
          border-radius: 2px;
          color: #000;
          transition: 0.2s;
          box-shadow: 0px 2px 2px #ccc;
        }
      }
    }
    .closeBtn {
      width: 100%;
      background: #2958ff;
      text-align: center;
      border-radius: 4px;
      padding: 10px;
      margin-bottom: 6px;
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>